// ===========================================================================
// Estilos da importação em lote v2 (rework 0060) — recriação em
// styled-components do alvo do Claude Design (mn2-lote.css): estado vazio
// (intro), revisão em cards e dropzone do modal de upload.
//
// Tokens de superfície/tinta/status vêm do protótipo (hardcode deliberado, como
// ScheduleStatusBadge já faz) — é a paleta desta tela. Os BOTÕES de ação usam o
// kit FC7 (styles/ui/Button.js); nada de cor de ação hardcoded aqui.
// ===========================================================================
import styled from 'styled-components';

import { FormCard } from '../manual/styles';

// ---------------------------------------------------------------------------
// Tokens do design (espelham as CSS vars do bundle)
// ---------------------------------------------------------------------------
const INK = '#2b3038';
const INK_SOFT = '#5b626d';
const LINE = '#e7eaef';
const LINE_SOFT = '#eef1f5';
const ACC = '#4098ef';
const ACC_TINT = '#eaf2fd';
const ACC_TINT2 = '#f3f8fe';
const PRIMARY_SOFT = '#96c4f0';
const OK_TINT = '#e8f4ee';
const OK_INK = '#1f8a5b';
const WARM_TINT = '#fdf1e8';
const WARM_INK = '#c9772f';
const WARM_INK2 = '#a85e29';
const WARM_BORDER = '#f0ddcb';
const ERR_TINT = '#fdeeee';
const ERR_INK = '#c14a45';

// ---------------------------------------------------------------------------
// Casca externa (limita a largura da aba, como o .mn2-single do protótipo)
// ---------------------------------------------------------------------------
export const BatchShell = styled.div`
   max-width: 1180px;
   margin: 0 auto;
`;

// ---------------------------------------------------------------------------
// Catálogo de roteirizações (Slice 2) — faixa informativa 5 dias × 2 períodos.
// Cores de status por célula vêm inline (--c/--cbg) espelhando ScheduleStatusBadge.
// ---------------------------------------------------------------------------
const CELL_BG = '#f4f6f9';

export const CatalogCard = styled.div`
   background: #fff;
   border: 1px solid ${LINE};
   border-radius: 16px;
   box-shadow:
      0 1px 2px rgba(0, 0, 0, 0.05),
      0 8px 30px rgba(0, 0, 0, 0.06);
   margin-bottom: 18px;
   position: relative;
`;

export const CatHead = styled.div`
   display: flex;
   align-items: center;
   gap: 14px;
   padding: 13px 18px;
   border-bottom: 1px solid ${LINE_SOFT};

   .cat-ic {
      width: 34px;
      height: 34px;
      border-radius: 10px;
      flex-shrink: 0;
      background: ${ACC_TINT};
      color: ${ACC};
      display: inline-flex;
      align-items: center;
      justify-content: center;
   }
   .tt {
      min-width: 0;
   }
   .tt .t {
      font-size: 14px;
      font-weight: 700;
      color: ${INK};
      letter-spacing: -0.01em;
   }
   .tt .d {
      font-size: 12px;
      color: ${INK_SOFT};
      margin-top: 1px;
   }
   .cat-nav {
      margin-left: auto;
      display: inline-flex;
      gap: 6px;
   }
   .cat-nav button {
      width: 32px;
      height: 32px;
      border-radius: 9px;
      border: 1px solid #dde2e9;
      background: #fff;
      color: ${INK};
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      transition: all 120ms ease;
   }
   .cat-nav button:hover {
      background: ${ACC};
      border-color: ${ACC};
      color: #fff;
   }

   @media (max-width: 880px) {
      flex-wrap: wrap;
   }
`;

export const BaseSeg = styled.div`
   display: inline-flex;
   background: ${LINE_SOFT};
   border-radius: 9px;
   padding: 3px;
   gap: 2px;

   button {
      appearance: none;
      border: none;
      background: none;
      cursor: pointer;
      color: ${INK_SOFT};
      font-size: 11.5px;
      font-weight: 700;
      padding: 6px 11px;
      border-radius: 7px;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      transition: all 120ms ease;
   }
   button:hover {
      color: ${INK};
   }
   button.active {
      background: #fff;
      color: ${ACC};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
   }
`;

export const CatTrack = styled.div`
   display: flex;
   gap: 8px;
   padding: 12px 18px 16px;
`;

export const CatRail = styled.div`
   display: flex;
   flex-direction: column;
   gap: 8px;
   flex-shrink: 0;
   width: 58px;

   .corner {
      height: 40px;
   }
   .plabel {
      flex: 1;
      min-height: 46px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 3px;
      font-size: 11.5px;
      font-weight: 700;
      color: ${INK_SOFT};
      text-align: right;
   }
`;

export const CatCol = styled.div`
   flex: 1;
   min-width: 0;
   display: flex;
   flex-direction: column;
   gap: 8px;

   .colhead {
      height: 40px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1px;
      background: ${({ $center }) => ($center ? INK : CELL_BG)};
      border: 1px solid ${({ $center }) => ($center ? INK : LINE_SOFT)};
   }
   .colhead .wd {
      font-size: 10.5px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      color: ${({ $center }) => ($center ? 'rgba(255,255,255,0.6)' : '#9aa1ab')};
   }
   .colhead .dt {
      font-size: 13px;
      font-weight: 700;
      color: ${({ $center }) => ($center ? '#fff' : INK)};
      font-variant-numeric: tabular-nums;
   }
   .colhead .today-tag {
      font-size: 9.5px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #fff;
      background: ${({ $center }) => ($center ? ACC : INK)};
      border-radius: 999px;
      padding: 1px 6px;
   }

   @media (max-width: 880px) {
      display: ${({ $center }) => ($center ? 'flex' : 'none')};
   }
`;

export const CatCell = styled.div`
   position: relative;
   flex: 1;
   min-height: 46px;
   border-radius: 10px;
   padding: 8px 10px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   gap: 3px;
   border: 1px solid transparent;
   background: var(--cbg, ${CELL_BG});
   box-shadow: ${({ $center }) =>
      ($center ? '0 0 0 1.5px rgba(64,152,239,0.28)' : 'none')};
   transition: transform 120ms ease;

   &:hover {
      transform: translateY(-1px);
      z-index: 5;
   }

   .cell-top {
      display: flex;
      align-items: baseline;
      gap: 5px;
   }
   .cell-dot {
      width: 7px;
      height: 7px;
      border-radius: 999px;
      background: var(--c, #b3b9c2);
      flex-shrink: 0;
      align-self: center;
   }
   .cell-count {
      font-size: 17px;
      font-weight: 800;
      color: ${INK};
      line-height: 1;
      font-variant-numeric: tabular-nums;
   }
   .cell-unit {
      font-size: 11px;
      color: ${INK_SOFT};
      font-weight: 600;
   }
   .cell-status {
      font-size: 11px;
      font-weight: 700;
      color: var(--c, ${INK_SOFT});
   }

   &:hover .cat-pop {
      opacity: 1;
      pointer-events: auto;
      transform: ${({ $edge }) =>
         ($edge === 'left' || $edge === 'right'
            ? 'translateX(0) translateY(0)'
            : 'translateX(-50%) translateY(0)')};
   }
`;

export const CatCellEmpty = styled.div`
   position: relative;
   flex: 1;
   min-height: 46px;
   border-radius: 10px;
   padding: 8px 10px;
   display: flex;
   align-items: center;
   justify-content: center;
   background: repeating-linear-gradient(
      135deg,
      #fbfcfd,
      #fbfcfd 7px,
      ${CELL_BG} 7px,
      ${CELL_BG} 14px
   );
   border: 1px dashed #dbe0e7;

   .cell-empty {
      font-size: 11px;
      color: #a2a9b3;
      font-weight: 600;
   }
`;

export const CatAdd = styled.button`
   position: absolute;
   top: 6px;
   right: 6px;
   width: 23px;
   height: 23px;
   border-radius: 7px;
   border: none;
   background: ${ACC};
   color: #fff;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   opacity: 0;
   transform: scale(0.7);
   transition:
      opacity 120ms ease,
      transform 120ms ease,
      background 120ms ease;
   z-index: 22;
   box-shadow: 0 2px 7px rgba(0, 0, 0, 0.22);

   ${CatCell}:hover &,
   ${CatCellEmpty}:hover &,
   &:focus-visible {
      opacity: 1;
      transform: scale(1);
   }
   &:hover {
      background: #2f86df;
   }

   @media (max-width: 880px) {
      opacity: 1;
      transform: scale(1);
   }
`;

export const CatPop = styled.div`
   position: absolute;
   top: calc(100% + 8px);
   width: 210px;
   background: #fff;
   border: 1px solid ${LINE};
   border-radius: 12px;
   box-shadow: 0 14px 40px rgba(0, 0, 0, 0.18);
   padding: 12px 13px;
   opacity: 0;
   pointer-events: none;
   transition:
      opacity 130ms ease,
      transform 130ms ease;
   z-index: 30;

   ${({ $edge }) => {
      if ($edge === 'left') {
         return 'left:-2px;right:auto;transform:translateX(0) translateY(4px);';
      }
      if ($edge === 'right') {
         return 'left:auto;right:-2px;transform:translateX(0) translateY(4px);';
      }
      return 'left:50%;transform:translateX(-50%) translateY(4px);';
   }}

   &::before {
      content: '';
      position: absolute;
      top: -6px;
      width: 11px;
      height: 11px;
      background: #fff;
      border-left: 1px solid ${LINE};
      border-top: 1px solid ${LINE};
      transform: rotate(45deg);
      ${({ $edge }) => {
         if ($edge === 'left') return 'left:14px;right:auto;';
         if ($edge === 'right') return 'left:auto;right:14px;';
         return 'left:50%;margin-left:-5.5px;';
      }}
   }

   .pop-h {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-bottom: 9px;
   }
   .pop-date {
      font-size: 12px;
      font-weight: 700;
      color: ${INK};
   }
   .pop-st {
      font-size: 10px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.03em;
      padding: 2px 7px;
      border-radius: 999px;
      color: var(--c);
      background: var(--cbg);
   }
   .pop-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px 10px;
   }
   .pop-m {
      display: flex;
      flex-direction: column;
      gap: 1px;
   }
   .pop-m .k {
      font-size: 10px;
      color: #9aa1ab;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 4px;
   }
   .pop-m .v {
      font-size: 13px;
      font-weight: 700;
      color: ${INK};
      font-variant-numeric: tabular-nums;
   }
   .pop-m.full {
      grid-column: span 2;
   }
`;

// ---------------------------------------------------------------------------
// Estado vazio (intro)
// ---------------------------------------------------------------------------
export const IntroCard = styled(FormCard)`
   max-width: none;
   text-align: center;
   padding: 48px 34px;
   display: flex;
   flex-direction: column;
   align-items: center;
`;

export const IntroIcon = styled.span`
   width: 64px;
   height: 64px;
   border-radius: 16px;
   background: ${ACC_TINT};
   color: ${ACC};
   display: inline-flex;
   align-items: center;
   justify-content: center;
   margin-bottom: 18px;
`;

export const IntroTitle = styled.h2`
   font-size: 19px;
   font-weight: 700;
   color: ${INK};
   margin: 0 0 8px;
   letter-spacing: -0.01em;
`;

export const IntroText = styled.p`
   font-size: 13.5px;
   color: ${INK_SOFT};
   line-height: 1.55;
   margin: 0 0 22px;
   max-width: 460px;
`;

// ---------------------------------------------------------------------------
// Modal de upload — chip do alvo + dropzone (o resto usa Field* do manual)
// ---------------------------------------------------------------------------
export const TargetChip = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 6px;
   margin-bottom: 4px;
   padding: 4px 10px;
   border-radius: 999px;
   font-size: 11.5px;
   font-weight: 600;
   color: ${INK};
   background: ${LINE_SOFT};

   .dotc {
      width: 6px;
      height: 6px;
      border-radius: 999px;
      background: ${ACC};
   }
`;

export const UploadDesc = styled.p`
   font-size: 12.5px;
   color: ${INK_SOFT};
   line-height: 1.5;
   margin: 12px 0 16px;

   b {
      font-weight: 700;
      color: ${INK};
   }
`;

export const DropZone = styled.div`
   margin-top: 6px;
   border: ${({ $filled }) => ($filled ? '1.5px solid' : '1.5px dashed')}
      ${({ $filled, $dragging }) =>
         $filled || $dragging ? ACC : '#ccd3dc'};
   border-radius: 14px;
   background: ${({ $filled, $dragging }) =>
      ($filled || $dragging ? ACC_TINT2 : '#fafbfd')};
   padding: 34px 24px;
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 6px;
   text-align: center;
   cursor: pointer;
   transition:
      border-color 130ms ease,
      background 130ms ease;

   &:hover {
      border-color: ${ACC};
      background: ${ACC_TINT2};
   }

   .drop-ic {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      background: ${ACC_TINT};
      color: ${ACC};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 4px;
   }
   .drop-t {
      font-size: 15px;
      font-weight: 700;
      color: ${INK};
   }
   .drop-s {
      font-size: 13px;
      color: ${ACC};
      font-weight: 600;
   }
   .drop-h {
      font-size: 12px;
      color: ${INK_SOFT};
   }
`;

export const FileChip = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 8px;
   font-size: 13px;
   font-weight: 700;
   color: ${INK};
   background: #fff;
   border: 1px solid ${LINE};
   border-radius: 999px;
   padding: 6px 13px;
   margin-top: 2px;

   .rm {
      border: none;
      background: none;
      color: ${INK_SOFT};
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      padding: 0;
   }
   .rm:hover {
      color: ${({ theme }) => theme?.colors?.danger ?? '#ab2020'};
   }
`;

// ---------------------------------------------------------------------------
// Revisão — cabeçalho de contexto
// ---------------------------------------------------------------------------
export const ReviewCard = styled(FormCard)`
   max-width: none;
   overflow: visible;
`;

export const ReviewTop = styled.div`
   display: flex;
   align-items: center;
   gap: 14px;
   padding: 16px 26px;

   .fic {
      width: 40px;
      height: 40px;
      border-radius: 11px;
      flex-shrink: 0;
      background: ${ACC_TINT};
      color: ${ACC};
      display: inline-flex;
      align-items: center;
      justify-content: center;
   }
   .file-txt {
      min-width: 0;
   }
   .fn {
      font-size: 14px;
      font-weight: 700;
      color: ${INK};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   }
   .fm {
      font-size: 12px;
      color: ${INK_SOFT};
      margin-top: 2px;
   }
   .rev-swap {
      margin-left: auto;
      flex-shrink: 0;
   }
`;

export const ReviewHead = styled.div`
   padding: 22px 26px;
   border-top: 1px solid ${LINE_SOFT};

   h2 {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: -0.01em;
      margin: 0 0 5px;
      color: ${INK};
   }
   p {
      font-size: 13px;
      color: ${INK_SOFT};
      margin: 0;
      line-height: 1.5;
   }
`;

// ---------------------------------------------------------------------------
// Chips de estatística
// ---------------------------------------------------------------------------
export const StatsRow = styled.div`
   display: flex;
   flex-wrap: wrap;
   gap: 8px;
   padding: 4px 26px 2px;
`;

export const StatChip = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 7px;
   font-size: 12px;
   font-weight: 700;
   padding: 6px 12px;
   border-radius: 999px;

   .n {
      font-variant-numeric: tabular-nums;
   }
   .dotc {
      width: 7px;
      height: 7px;
      border-radius: 999px;
      background: currentColor;
   }

   ${({ $variant }) => {
      if ($variant === 'ok') return `background:${OK_TINT};color:${OK_INK};`;
      if ($variant === 'warn') return `background:${WARM_TINT};color:${WARM_INK};`;
      if ($variant === 'gps') return `background:${ERR_TINT};color:${ERR_INK};`;
      if ($variant === 'err') return `background:${ERR_TINT};color:${ERR_INK};`;
      return `background:${LINE_SOFT};color:${INK_SOFT};`;
   }}
`;

// ---------------------------------------------------------------------------
// Toolbar (filtros + selecionar visíveis)
// ---------------------------------------------------------------------------
export const Toolbar = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   padding: 14px 26px 2px;
   flex-wrap: wrap;
`;

export const Filters = styled.div`
   display: inline-flex;
   gap: 4px;
`;

export const FilterButton = styled.button`
   appearance: none;
   border: 1px solid ${({ $active }) => ($active ? 'rgba(64,152,239,0.28)' : 'transparent')};
   background: ${({ $active }) => ($active ? ACC_TINT : 'none')};
   color: ${({ $active }) => ($active ? ACC : INK_SOFT)};
   cursor: pointer;
   font-size: 12.5px;
   font-weight: 600;
   padding: 8px 14px;
   border-radius: 999px;
   display: inline-flex;
   align-items: center;
   gap: 6px;
   transition: all 120ms ease;

   &:hover {
      background: ${({ $active }) => ($active ? ACC_TINT : '#f0f2f5')};
      color: ${({ $active }) => ($active ? ACC : INK)};
   }
   .n {
      font-variant-numeric: tabular-nums;
      opacity: 0.8;
   }
`;

export const SelectAllButton = styled.button`
   margin-left: auto;
   appearance: none;
   border: 1px solid #dde2e9;
   background: #fff;
   cursor: pointer;
   color: ${INK};
   font-size: 12.5px;
   font-weight: 600;
   padding: 8px 13px;
   border-radius: 9px;
   display: inline-flex;
   align-items: center;
   gap: 8px;
   transition: all 120ms ease;

   &:hover {
      background: #f4f8fe;
      border-color: ${ACC};
   }
`;

// ---------------------------------------------------------------------------
// Checkbox (visual — o controle de acessibilidade é o card com role=checkbox)
// ---------------------------------------------------------------------------
export const CheckBox = styled.span`
   width: ${({ $sm }) => ($sm ? '17px' : '20px')};
   height: ${({ $sm }) => ($sm ? '17px' : '20px')};
   border-radius: ${({ $sm }) => ($sm ? '5px' : '6px')};
   border: 2px solid
      ${({ $on, $disabled }) => {
         if ($disabled) return '#dbe0e7';
         return $on ? ACC : '#c3cad4';
      }};
   background: ${({ $on, $disabled }) => {
      if ($disabled) return '#eef0f3';
      return $on ? ACC : '#fff';
   }};
   color: #fff;
   cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
   display: inline-flex;
   align-items: center;
   justify-content: center;
   flex-shrink: 0;
   transition: all 110ms ease;
`;

// ---------------------------------------------------------------------------
// Lista + card de item
// ---------------------------------------------------------------------------
export const List = styled.div`
   display: flex;
   flex-direction: column;
   gap: 10px;
   padding: 14px 26px 4px;
`;

export const EmptyList = styled.div`
   padding: 40px 20px;
   text-align: center;
   color: ${INK_SOFT};
   font-size: 13px;
`;

export const Card = styled.div`
   display: flex;
   align-items: flex-start;
   gap: 13px;
   padding: 14px 15px;
   border: 1px solid ${LINE};
   border-radius: 13px;
   background: #fff;
   transition:
      border-color 120ms ease,
      background 120ms ease,
      box-shadow 120ms ease;

   ${({ $disabled, $selected }) => {
      if ($disabled) {
         return `background:#fbfbfc;border-style:dashed;opacity:0.85;cursor:not-allowed;`;
      }
      if ($selected) {
         return `border-color:${ACC};background:${ACC_TINT2};box-shadow:0 0 0 1px ${ACC} inset;cursor:pointer;`;
      }
      return `cursor:pointer;&:hover{border-color:${PRIMARY_SOFT};}`;
   }}

   &:focus-visible {
      outline: 2px solid ${ACC};
      outline-offset: 2px;
   }

   > ${CheckBox} {
      margin-top: 3px;
   }
`;

export const Avatar = styled.span`
   width: 40px;
   height: 40px;
   border-radius: 999px;
   flex-shrink: 0;
   background: ${({ $disabled }) => ($disabled ? '#b6bcc6' : ACC)};
   color: #fff;
   font-weight: 700;
   font-size: 13px;
   display: inline-flex;
   align-items: center;
   justify-content: center;
`;

export const CardBody = styled.div`
   flex: 1;
   min-width: 0;

   .bir1 {
      display: flex;
      align-items: flex-start;
      gap: 12px;
   }
   .id {
      min-width: 0;
      flex: 1;
   }
   .nm {
      font-size: 14.5px;
      font-weight: 700;
      color: ${INK};
      line-height: 1.25;
   }
   .sub {
      font-size: 12px;
      color: ${INK_SOFT};
      margin-top: 3px;
      display: flex;
      align-items: center;
      gap: 7px;
      flex-wrap: wrap;
   }
   .sub .ln {
      font-weight: 600;
   }
   .sub .sep {
      opacity: 0.4;
   }
   .sub .pn {
      font-variant-numeric: tabular-nums;
      font-weight: 600;
   }
   .side {
      text-align: right;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 5px;
   }
   .val {
      font-size: 15px;
      font-weight: 800;
      color: ${INK};
      font-variant-numeric: tabular-nums;
      white-space: nowrap;
   }
   .jan {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      font-size: 11px;
      font-weight: 700;
      color: ${WARM_INK2};
      background: ${WARM_TINT};
      border: 1px solid ${WARM_BORDER};
      border-radius: 999px;
      padding: 3px 9px;
      white-space: nowrap;
   }
   .jan-none {
      font-size: 11px;
      color: #c3c9d1;
      font-weight: 600;
   }
   .bir2 {
      display: flex;
      align-items: flex-start;
      gap: 7px;
      font-size: 12.5px;
      color: ${INK_SOFT};
      line-height: 1.4;
      margin-top: 9px;
   }
   .bir2 .pin {
      color: ${ACC};
      flex-shrink: 0;
      margin-top: 1px;
      opacity: 0.75;
   }
   .bir3 {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
      margin-top: 11px;
      padding-top: 11px;
      border-top: 1px solid ${LINE_SOFT};
   }

   @media (max-width: 880px) {
      .bir1 {
         flex-direction: column;
         gap: 8px;
      }
      .side {
         text-align: left;
         align-items: flex-start;
         flex-direction: row;
         gap: 10px;
      }
   }
`;

export const StatusPill = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 5px;
   font-size: 11px;
   font-weight: 800;
   padding: 3px 10px;
   border-radius: 999px;
   flex-shrink: 0;

   ${({ $variant }) => {
      if ($variant === 'ok') return `background:${OK_TINT};color:${OK_INK};`;
      if ($variant === 'err') return `background:${ERR_TINT};color:${ERR_INK};`;
      return `background:${WARM_TINT};color:${WARM_INK};`;
   }}
`;

export const CardNote = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 5px;
   font-size: 11.5px;
   line-height: 1.35;
   color: ${({ $variant }) => ($variant === 'err' ? ERR_INK : WARM_INK)};

   .pn {
      font-variant-numeric: tabular-nums;
      font-weight: 700;
   }
`;

// ---------------------------------------------------------------------------
// Rodapé
// ---------------------------------------------------------------------------
export const ReviewFoot = styled.div`
   display: flex;
   align-items: center;
   gap: 14px;
   padding: 16px 26px;
   border-top: 1px solid ${LINE};
   background: #fbfcfd;
   flex-wrap: wrap;
   margin-top: 8px;

   .cnt {
      font-size: 13px;
      color: ${INK_SOFT};
   }
   .cnt b {
      color: ${INK};
      font-variant-numeric: tabular-nums;
   }
   .acts {
      display: flex;
      gap: 10px;
      margin-left: auto;
   }
`;

// Erros da planilha — cards não-selecionáveis (read-only) num bloco à parte.
export const ErrorBlock = styled.div`
   padding: 4px 26px 8px;

   .eh {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12.5px;
      font-weight: 700;
      color: ${ERR_INK};
      margin: 10px 0 8px;
   }
`;

export const ErrorRow = styled.div`
   display: flex;
   align-items: baseline;
   gap: 10px;
   padding: 9px 12px;
   border: 1px dashed ${WARM_BORDER};
   border-radius: 10px;
   background: #fbfbfc;
   font-size: 12.5px;
   color: ${INK_SOFT};
   margin-bottom: 6px;

   .ln {
      font-weight: 700;
      color: ${ERR_INK};
      white-space: nowrap;
   }
   .pn {
      font-variant-numeric: tabular-nums;
      font-weight: 600;
      color: ${INK};
      white-space: nowrap;
   }
   .msg {
      flex: 1;
   }
`;
